import { 
  UPDATE_PVS_REGISTRATION_FAILURE, 
  UPDATE_PVS_REGISTRATION_REQUEST, 
  UPDATE_PVS_REGISTRATION_RESET, 
  UPDATE_PVS_REGISTRATION_SUCCESS 
} from "../../../../redux/types/pvs";

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const updatePvsRegistrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PVS_REGISTRATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: ""
      };

    case UPDATE_PVS_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: (action.payload && action.payload.message) || "PVS registration updated successfully"
      };

    case UPDATE_PVS_REGISTRATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload && action.payload.message,
        success: false,
        message: ""
      };

    case UPDATE_PVS_REGISTRATION_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default updatePvsRegistrationReducer
